import React, { useState, useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import Header from '../components/Header'
import Footer from '../components/Footer'
import SharePopup from '../components/SharePopup';
import { db } from '../util/firebaseApp'
import { doc, setDoc, collection } from 'firebase/firestore'
import axios from 'axios';

const BookCollection = () => {
    const apiUrl = process.env.REACT_APP_API_URL;

    const [formStatus, setFormStatus] = useState('Submit');
    const form = useRef();
    const [bank, setBank] = useState();
    const [sharePopupActive, setSharePopup] = useState(false);
    const [searchParams] = useSearchParams();
    const [bankId, setBankId] = useState("");
    const [shareActive, setShareState] = useState(false);
    const [campaignId, setCampaignId] = useState("");
    const [collectAddress, setAddress] = useState("");
    const [collectName, setName] = useState("");

    useEffect(() => {
        setBankId(searchParams.get('bankId') ? searchParams.get('bankId') : "yewkids-nursery");
        console.log("API URL " + apiUrl);
    }, []);

    useEffect(() => {
        getBankInfo();
    }, [bankId]);

    const getBankInfo = async () => {
        console.log("Getting Bank Info")
        if (!bank) {
            console.log("Request to: " + `${apiUrl}/bank/${bankId}`)
            axios
                .get(`${apiUrl}/bank/${bankId}`)
                .then((res) => {
                    console.log("Found Bank: " + res.data.name)
                    setBank(res.data)
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        setFormStatus("Submitting...");
        const { name, email, phone, address, date, notes, isdropoff } = e.target.elements;
        let collectionForm = {
            name: name.value,
            email: email.value,
            phone: phone.value, 
            bankId: bankId,
            address: address.value,
            date: date.value,
            notes: notes.value,
            isdropoff: isdropoff.value
        }
        console.log(collectionForm);
        setAddress(address.value);
        setName(name.value);

        //const newCollection = doc(collection(db, "collectionCampaigns"));
        //await setDoc(newCollection, collectionForm);

        incrementShareCount();

        axios
            .post(`${apiUrl}/collectionrequest/submit-request `, collectionForm)
            .then((response) => {
                console.log(response);
                setCampaignId(response.data.request_id)
                setShareState(true)
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error)
                }
                console.log(error)
                alert("Submission failed, please try again");
            })
    }

    const incrementShareCount = async () => {
        console.log("Increasing share count.");
        console.log(bank)
        var request = `${apiUrl}/bank/inc-share/${bank['bankId'] ? bank['bankId'] : bank.id}`;

        axios
            .get(request)
            .then((response) => {
                console.log(response);
                setShareState(true);
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error)
                }
                console.log(error)
                //alert("Share count update failed, please try again");
            })
    }

    return (
        <PageContainer>
            {
                sharePopupActive ?
                <SharePopup exitFunction={setSharePopup} /> :
                ""
            }
            <Header />
            <PageContent>
                <Columns>
                    <LeftColumn>
                        <Swirl src={require('../assets/images/hero-swirl.svg').default} />
                        <Title>Start a fundraising campaign by organising a group collection</Title>
                        <Subtitle>Share to minimum of 10 people to join your fundraising campaign for {bank ? bank.name : "Fundraise & Recycle"}.</Subtitle> :
                    </LeftColumn>
                    <RightColumn>
                    {
                        !shareActive ?
                        <Form ref={form} onSubmit={onSubmit} className="sponsor-form" noValidate>
                            <div className="form-field-container horizontal">
                                <label className="form-label" htmlFor="name">Name:* </label>
                                <input className="form-control" name="name" type="text" id="name" required />
                            </div>
                            <div className="form-field-container horizontal">
                                <label className="form-label" htmlFor="email">Email:*</label>
                                <input className="form-control" name="email" type="text" id="email" required />
                            </div>
                            <div className="form-field-container horizontal">
                                <label className="form-label" htmlFor="phone">Contact Number:*</label>
                                <input className="form-control" name="phone" type="text" id="phone" required />
                            </div>
                            <div className="form-field-container vertical">
                                <label className="form-label" htmlFor="isdropoff">Campaign members will drop their clothes off at the location specified below.</label>
                                <input type="checkbox" className="form-control" name="isdropoff" id="isdropoff" />
                            </div>
                            <div className="form-field-container vertical">
                                <label className="form-label" htmlFor="address">Drop Off / Collection Address</label>
                                <textarea className="form-control" name="address" id="address" placeholder="For a campaign, enter the organisaition's address for drop off. For a home collection, Enter your home address." />
                            </div>
                            <div className="form-field-container vertical">
                                <label className="form-label" htmlFor="notes">Notes</label>
                                <textarea className="form-control" name="notes" id="notes" placeholder="Please Note things like: Clothes bank accessibility times, describe bank location on your site, or any other note you might have for campaigners you invite." />
                            </div>
                            <div className="form-field-container vertical">
                                <label className="form-label" htmlFor="date">Campaign End Date</label>
                                <input className="form-control" name="date" type="date" id="date" />
                            </div>
                            <div className="form-field-container checkbox">
                                <label className="form-label" htmlFor="mailTick">I want to join the Fundraise & Recycle Mailing List</label>
                                <input className="form-control" type="checkbox" id="mailTick" defaultChecked />
                            </div>
                            <button className="btn btn-danger" type="submit">
                                {formStatus}
                            </button>
                        </Form> :
                        <>
                            <ol>
                                <li>It’s time to share your fundraising campaign! </li>
                                <li>⁠Click the share my campaign button. </li>
                                <li>⁠Line up 10 or more keen recyclers looking to clear out their wardrobes.</li>
                                <li>⁠Invite them to join your fundraising campaign and support your organisation. </li>
                                <li>⁠Spread awareness and knowledge of your fundraising and recycling campaign. </li>
                                <li>⁠Watch the momentum build as you receive their acceptance emails.</li>
                            </ol>
                            <>
                                <ShareDirectText>Share this link directly with everyone you want to join your campaign:</ShareDirectText>
                                <ShareDirectText><a href={`https://online.fundraiserecycle.com/bank?bankId=${bankId}&campaignid=${campaignId}`}>{`https://online.fundraiserecycle.com/bank?bankId=${bankId}&campaignid=${campaignId}`}</a></ShareDirectText>
                                <ShareButton className="cta-3" onClick={() => {
                                    if (navigator.share) {
                                        navigator.share({
                                            title: window.title,
                                            text: `Hi,\n\nI’m inviting you to support ${bank ? bank.name : "this organisation"} by clearing out your wardrobe!\n\nThey’re running a fundraising campaign by recycling unwanted clothes—and we can all make a difference. 💼👗👟👜🎁✨\n\nSimply gather clothes, shoes, handbags, gift sets, or jewelry you no longer need and drop them off at:\n\n👉 ${collectAddress}\n\nPlease share this with as many friends and family as you want! Thank you so much!\n\nWarm regards,\n${collectName}`,
                                            url: `/bank?bankId=${bankId}&campaignid=${campaignId}`,
                                        })
                                            .then(() => {
                                                console.log('Successful share');
                                                incrementShareCount();
                                            })
                                            .catch((error) => console.log('Error sharing', error));
                                    } else {
                                        incrementShareCount();
                                        setSharePopup(true);
                                    }
                                }}>
                                    <p>SHARE MY CAMPAIGN!</p>
                                </ShareButton>
                            </>
                        </>
                    }
                    </RightColumn>
                </Columns>
            </PageContent>
            <Footer />
        </PageContainer>
    )
}

export default BookCollection

const PageContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (max-width: 1060px) {
        background: #F8FDFF
    }
`

const Columns = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 20px;
    gap: 20px;

    @media (max-width: 1080px) {
        flex-direction: column;
    }
`

const LeftColumn = styled.div`
    max-width: 40%;
    width: 100%;
    background: #0F678F;
    overflow: hidden;
    border-radius: 30px;
    padding: 60px 20px;
    position: relative;
    min-height: 400px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    @media (max-width: 1080px) {
        max-width: 100%;
    }
`

const RightColumn = styled.div`
    max-width: 430px;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;

    @media (max-width: 1080px) {
        max-width: 100%;
        align-items: center;
    }
`

const PageContent = styled.div`
    max-width: 1296px;
    width: 100%;
    min-height: 68vh;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    ol {
        margin: 0;
    }

    ol li {
        font-size: 24px;
        line-height: 42px;
        color: black;
        margin: 5px 0;
    }
`

const Title = styled.h1`
    font-size: 48px;
    font-weight: bold;
    padding-left: 18px;
    color: white;
    margin: 0;
    z-index: 5;
`

const Subtitle = styled.h2`
    padding-left: 18px;
    color: white;
    margin-bottom: 0;
    font-weight: normal;
    z-index: 5;
    font-size: 32px;
`

const Paragraph = styled.p`

`

const Form = styled.form`
    box-sizing: border-box;
    max-width: 470px;
    width: 100%;
    padding: 0 24px 24px 24px;
    
    .form-field-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        margin-top: 24px;
    }

    .form-field-container.horizontal {
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        label {
            margin: 0;
            min-width: min-content;
        }
    }

    input,
    textarea,
    select {
        box-sizing: border-box;
        width: 100%;
        padding: 12px;
        outline: 0;
        border: 0;
    }

    input,
    textarea {
        background: #E5E5E5;
        border-radius: 30px;
    }

    input[type="checkbox"] {
        width: min-content;
    }

    #adPhoto {
        padding: 0;
    }

    label {
        color: black;
        margin-bottom: 8px;
        font-size: 18px;
        box-sizing: border-box;
    }

    button {
        border: 0;
        padding: 18px 24px;
        border-radius: 30px;
        font-size: 22px;
        background: #EF3E3C;
        width: 100%;
        color: white;
        margin-top: 24px;
    }

    .form-field-container.checkbox {
        flex-direction: row;
        justify-content: flex-start;
    }

    .form-field-container.checkbox label {
        order: 2;
    }

    .form-field-container.checkbox input {
        order: 1;
    }

    #acceptTick {
        width: auto;
    }
`

const ShareButton = styled.a`
    width: 100%;
    margin-top: 20px;
    background: #EF3E3C;
    color: white;
    text-align: center;

    border-radius: 50px;

    p {
        color: white;
        padding: 0 20px;
        font-weight: bold;
    }

    :hover {
        text-decoration: underline;
        cursor: pointer;
    }
`

export const Swirl = styled.img`
    position: absolute;
    width: 150%;
    transform: rotateZ(-90deg);
    right: -30%;
    bottom: 100px;

    @media (max-width: 1080px) {
        min-width: 100%;
        min-height: 100%;;
        object-fit: cover;
        left: -10%;
        top: 10%;
    }
`

const ShareDirectText = styled.p`
    margin-bottom: 0;
    font-size: 22px;
`